import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from 'src/app/core/services/event.service';
import { ScriptService } from 'src/app/core/services/script.service';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-filtrocanvas',
  templateUrl: './filtrocanvas.component.html',
  styleUrls: ['./filtrocanvas.component.scss']
})
export class FiltrocanvasComponent implements OnInit {
  @Input() form_template: any[];
  @Input() strListener: string = '';
  @Input() TipoPantalla: string = '';
  @Input() JavaScript: string = "";
  @Input() formFiltros = null;
  @Input() reportes = [];
  @Input() WsLlaves: any = '';
  @Input() SYS02CON: any = '';
  @Input() estructura:any = null;
  @Input() filtrosAvanzados = null;

  @Output() abrirNav = new EventEmitter<any>();

  myFormGroup: FormGroup;
  strWsURLModal: string = '';
  strTituloPantallaModal: string = '';
  scriptElement: any;
  campos: any;
  isCollapsed = true;
  collapsedReportes = true;
  modal_element_label: any;
  modal_element_type: any;
  formespecial = [];
  ngmodels = new Object();
  reporteSel = null;
  tipoReporteSel = null;

  filtro_guardado = [];
  filtroSel = null;
  intSYS02CON: string;
  filtroGuardado:boolean = false

  jsonReporte = { FILTROS_OPCIONALES: null, FILTROS_OBLIGATORIOS: null, SYS02CON: null, SYS10CON: null, FORMATO: "PDF", TSTAMP: null, TITULO: "" };

  constructor(private eventService: EventService,
    private dataService: SharedService,
    private renderer: Renderer2,
    private scriptService: ScriptService,
    private modalService: NgbModal,
    public activeOffcanvas: NgbActiveOffcanvas
  ) { }

  ngOnInit(): void {
    this.CrearFormulario();
  }

  ngAfterViewInit(): void {
    this.CargarScript();
    if (this.SYS02CON != '') {
      this.SELECT_FILTRO();
    }
    
  }

  CargarScript() {
    if (this.JavaScript !== "undefined") {
      if (this.JavaScript != "")
        this.scriptElement = this.scriptService.loadJsScript(this.renderer, this.JavaScript);
    }
  }

  CrearFormulario() {
    let group = {};
    if (this.form_template !== undefined && this.form_template != null) {
      for (const i in this.form_template) {
        for (const j in this.form_template[i].FiltrosExpuestos) {
          let valor = this.form_template[i].FiltrosExpuestos[j].value;
          if (this.form_template[i].FiltrosExpuestos[j].label == "M12CAR") {
            this.campos = JSON.parse("{ \"M12CAR\" : \"" + valor + "\"}")
          }
          if (this.form_template[i].FiltrosExpuestos[j].type == 'textbox_date' && valor != '') {
            valor = formatDate(valor, 'dd/MM/yyyy', 'en');
          }
          if (this.form_template[i].FiltrosExpuestos[j].type == 'select_multiple' && valor != '') {
            this.ngmodels[this.form_template[i].FiltrosExpuestos[j].label] = [];
          }
          if (this.form_template[i].FiltrosExpuestos[j].SYS03ALI != undefined) {
            this.formespecial[this.form_template[i].FiltrosExpuestos[j].label] = this.form_template[i].FiltrosExpuestos[j].SYS03ALI;
          }

          group[this.form_template[i].FiltrosExpuestos[j].label] = new FormControl(valor, []);
        }
      }
    }

    this.myFormGroup = null;
    if (this.formFiltros != null) {
      for (const i of Object.keys(this.formFiltros)) {
        let elem = this.getElemento(i);
        if(elem != null){
          if (elem.type == 'select_multiple') {
            this.ngmodels[i] = this.formFiltros[i].replaceAll("'", "").split(",");
          } else {
            group[i].value = this.formFiltros[i];
          }
        }
      }
    }
    this.myFormGroup = new FormGroup(group);
    this.opcionesCombos();
  }

  toggleAvanzados() {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleReportes() {
    this.collapsedReportes = !this.collapsedReportes;
  }

  DemeFormulario() {
    return
  }

  guardarFiltro(filtro){
    localStorage.setItem('filtro'+this.strListener,JSON.stringify(filtro));
  }

  formatearFormulario(form) {
    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }
  
      if (Array.isArray(form[key])) {
        form[key] = "'" + form[key].join("','") + "'";
      }
      if (form[key] == Number(form[key])) {
        form[key] = String(form[key]);
      }
  

      let elemento = this.getObtenerCodigoCampo(key);
      if (elemento && elemento.type === "textbox_date" && form[key] != "") {
        form[key] = formatDate(form[key], 'dd/MM/yyyy', 'en');
      }
    }
  
    return form;
  }

  getElemento(label) {
    for (const i in this.form_template) {
      for (const j in this.form_template[i].FiltrosExpuestos) {
        if (this.form_template[i].FiltrosExpuestos[j].label == label) {
          return this.form_template[i].FiltrosExpuestos[j];
        }
      }
    }

    return null;
  }


  ValidarFormulario() {
    if (this.myFormGroup.valid) {
      let objForm = {};
      if(this.filtroGuardado){
        objForm = this.formFiltros;
      }else{
        objForm = this.myFormGroup.value;
      }
      this.guardarFiltro(objForm);

      if(this.filtrosAvanzados != null){
        objForm = {...objForm, ...this.filtrosAvanzados};
      }
      this.activeOffcanvas.close(objForm);
    } else {
      alert('campos necesarios');
    }
  }

  AbrirModal(contenido, elemento) {

    this.modal_element_label = elemento.label;
    this.modal_element_type = elemento.type;

    this.strWsURLModal = "api/mantenimientos/ListarGenerico/" + elemento.id_modal;
    this.strTituloPantallaModal = elemento.titulo_modal;
    this.modalService.open(contenido, { size: 'xl' });
  }

  RetornoModal(event) {
    if (event.length > 0) {
      let retorno = event[0];
      let claves = Object.keys(retorno);
      claves.forEach((key) => {
        if (key == "TSTAMP") {
          key = this.myFormGroup.value.TSTAMP;
        } else if (this.modal_element_label == key) {
          const formControl = this.myFormGroup.get(key);
          if (formControl) {
            formControl.setValue(retorno[key]);
          }
        } else if (this.modal_element_label != key) {
          if (this.TienePropiedad(key)) {
            if (claves.length <= 2) {
              const formControl = this.myFormGroup.get(this.modal_element_label);
              formControl.setValue(retorno[key]);
            } else {
              const formControl = this.myFormGroup.get(key);
              formControl.setValue(retorno[key]);
            }
          } else {
            const formControl = this.myFormGroup.get(key);
            if (formControl != null) {
              formControl.setValue(retorno[key]);
            }
          }
        }
      });
    }

    this.modalService.dismissAll();
  }

  TienePropiedad(propiedad) {
    for (const key in this.formespecial) {
      if (this.formespecial[key] == propiedad && key == this.modal_element_label) {
        return true;
      }
    }
    return false;
  }

  enter(event) {
    if (event.keyCode == '13') {
      this.ValidarFormulario();
    }
  }

  // almora 2021.11.06 Destroy se ejecuta
  ngOnDestroy(): void {
    if (this.form_template !== undefined && this.form_template != null) {
      this.form_template.forEach(input_template => {
        input_template = null;
      });
    }
    this.myFormGroup.reset();
    this.myFormGroup = null;
    this.form_template = null;
    if (this.JavaScript != "")
      this.scriptElement.parentNode.removeChild(this.scriptElement);
  }

  toJSON(operacion: string, arr: any, url?: string, extra?: string) {
    let jsonReturn = { TITULO: "Reporte Nav", URL: "", EXTRA: "", OPERACION: null, LLAVES: null };
    jsonReturn.LLAVES = arr;
    if (url != null) {
      jsonReturn.URL = url;
    }
    if (extra != null) {
      jsonReturn.EXTRA = extra;
    }
    jsonReturn.OPERACION = operacion;

    return jsonReturn;
  }

  toJSONFiltros(operacion: string, arr: any, url?: string, titulo?: string, extra?: string) {
    let NavID = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
    return JSON.parse("{ \"LLAVES\"   :" + JSON.stringify(arr) +
      (url != null ? (", \"URL\"      :\"" + url + "\"") : "") +
      (titulo != null ? (", \"TITULO\"      :\"" + titulo + "\"") : "") +
      (extra != null ? ("," + extra) : "") +
      ", \"NAV_ID\"   : \"" + NavID + "\"" +
      ", \"OPERACION\": \"" + operacion + "\"}");
  }

  CboClick(blnClick, strComboClickDestName) {
    if (blnClick == "S") {
      this.form_template.forEach(input_template => {
        for (let i = 0; i < input_template.FiltrosExpuestos.length; i++) {
          if (input_template.FiltrosExpuestos[i].label == strComboClickDestName) {
            let llaves = JSON.stringify(this.formatearFormulario(this.myFormGroup.value));
            let jsonFiltros = JSON.parse("{ \"LLAVES\"   : [" + llaves + "]}");
            this.dataService.Ejecutar("api/mantenimientos/ListarCombo/" + input_template.FiltrosExpuestos[i].ComboClickURL, jsonFiltros).subscribe(
              (datosResp: any) => {
                input_template.FiltrosExpuestos[i].options = datosResp;
                input_template.FiltrosExpuestos[i].value = "";
              },
              error => {
                Swal.fire({
                  title: 'Error',
                  text: error,
                  icon: 'error',
                })
              }
            );
          }
        }
      });
    }
  }

  opcionesCombos() {
    if (this.myFormGroup != undefined) {
      for (const i in this.form_template) {
        for (const j in this.form_template[i].FiltrosExpuestos) {
          let control = this.myFormGroup.get(this.form_template[i].FiltrosExpuestos[j].label);
          if (this.form_template[i].FiltrosExpuestos[j].type == 'select' && control.value != '') {
            this.CboClick(this.form_template[i].FiltrosExpuestos[j].ComboClick, this.form_template[i].FiltrosExpuestos[j].ComboClickDestName);
          }
        }
      }
    }
  }

  SelectReporte() {
    for (const key in this.reportes) {
      if (this.reportes[key]['SYS10CON'] == this.reporteSel) {
        if (this.tipoReporteSel == 'NAV') {
          this.AbrirReportePDFNav(this.reportes[key]['SYS02CON'], this.reportes[key]['SYS10CON'], this.reportes[key]['TSTAMP'], this.reportes[key]['SYS10DES']);
        } else {
          this.VerReporte(this.reportes[key]['SYS02CON'], this.reportes[key]['SYS10CON'], this.reportes[key]['TSTAMP'], this.tipoReporteSel);
        }
        break;
      }
    }

    setTimeout(() => {
      this.tipoReporteSel = null;
    }, 1500);
  }

  VerReporte(intSYS02CON: string, intSYS10CON: string, intTSTAMP: string, strFORMATO: string, llaves?) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }
    

    this.jsonReporte.FILTROS_OBLIGATORIOS = llaves;
    this.jsonReporte.FORMATO = strFORMATO;
    this.jsonReporte.SYS02CON = intSYS02CON;
    this.jsonReporte.SYS10CON = intSYS10CON;
    this.jsonReporte.TSTAMP = intTSTAMP;
    this.jsonReporte.TITULO = "";
    if (this.formFiltros == null) {
      this.jsonReporte.FILTROS_OPCIONALES = [{...this.formatearFormulario(this.myFormGroup.value), ...this.filtrosAvanzados}];
    } else {
      this.jsonReporte.FILTROS_OPCIONALES = [{...this.formatearFormulario(this.formFiltros), ...this.filtrosAvanzados}];
    }
    

    let json = this.toJSON('ABRIR_REPORTE_PDF', this.jsonReporte, 'api/mantenimientos/VerReporte/' + intSYS02CON + '/' + intSYS10CON + '/' + intTSTAMP, "");
    this.dataService.ConsultarWS('api/mantenimientos/VerReporte/' + intSYS02CON + '/' + intSYS10CON + '/' + intTSTAMP, JSON.stringify(json)).subscribe(
      (datosResp: any) => {
        const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
        const blob = this.dataURItoBlob(base64, strFORMATO);
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      },
      error => {
        this.tipoReporteSel = null;
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );
  }

  AbrirReportePDFNav(intSYS02CON: string, intSYS10CON: string, intTSTAMP: string, strSYS10DES: string, llaves?) {
    if (llaves == undefined) {
      llaves = this.WsLlaves;
    }
    this.jsonReporte.FILTROS_OBLIGATORIOS = llaves;
    this.jsonReporte.FORMATO = "PDF";
    this.jsonReporte.SYS02CON = intSYS02CON;
    this.jsonReporte.SYS10CON = intSYS10CON;
    this.jsonReporte.TSTAMP = intTSTAMP;
    this.jsonReporte.TITULO = strSYS10DES;
    if (this.formFiltros == null) {
      this.jsonReporte.FILTROS_OPCIONALES = [{...this.formatearFormulario(this.myFormGroup.value), ...this.filtrosAvanzados}];
    } else {
      this.jsonReporte.FILTROS_OPCIONALES = [{...this.formatearFormulario(this.formFiltros), ...this.filtrosAvanzados}];
    }
    let json = this.toJSON('ABRIR_REPORTE_PDF', this.jsonReporte, 'api/mantenimientos/VerReporte/' + intSYS02CON + '/' + intSYS10CON + '/' + intTSTAMP, strSYS10DES);
    this.abrirNav.emit(json);
    this.activeOffcanvas.dismiss();
  }

  dataURItoBlob(dataURI, strFORMATO) {
    let strType = "application/pdf";
    if (strFORMATO == "XLS") strType = "application/vnd.ms-excel";
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  SELECT_FILTRO() {
    let strjson = [{
      SYS20FIL: {},
      SYS20COD: "",
      SYS20DES: "",
      SYS02CON: this.SYS02CON
    }];
    let url = "api/filtros/Grabar/SEL/" + this.SYS02CON;
    let json = this.toJSONFiltros("SEL", strjson, url);

    this.dataService.ConsultarWS(url, json).subscribe(
      (datosResp: any) => {
        this.filtro_guardado = datosResp.DATA;
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        });
      }
    );
  }

  GuardarFiltro() {
    if (this.formFiltros != null) {
      Swal.fire({
        title: 'Nombre del Filtro',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          let objForm = {...this.myFormGroup.value, ...this.filtrosAvanzados};
          let strjson = {
            SYS20FIL: objForm,
            SYS20COD: "",
            SYS20DES: result.value,
            SYS02CON: this.SYS02CON
          };
          let strjson2 = [strjson];
          let url = "api/filtros/Grabar/ADD/" + this.SYS02CON;
          // Armo el JSON
          let json = this.toJSONFiltros("ADD", strjson2, url);
          this.dataService.ConsultarWS(url, json).subscribe(
            (datosResp: any) => {
              this.SELECT_FILTRO();
              Swal.fire({
                position: 'top-end',
                toast: true,
                icon: 'success',
                text: 'Dato Grabado exitosamente',
                showConfirmButton: false,
                timer: 5000
              });
            },
            error => {
              Swal.fire({
                title: 'Error',
                text: error,
                icon: 'error',
              });
            }
          );
        }

      });
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Debe aplicar un filtro primero',
        icon: 'error',
      });
    }
  }

  DELETE_FILTRO() {
    if (this.filtroSel != null) {
      let strjson = [{
        SYS20FIL: {},
        SYS20COD: this.filtroSel.SYS20COD,
        SYS20DES: "",
        SYS02CON: this.SYS02CON
      }];

      let url = "api/filtros/Grabar/DEL/" + this.SYS02CON;
      let json = this.toJSONFiltros("DEL", strjson, url);
      this.dataService.ConsultarWS(url, json).subscribe(
        (datosResp: any) => {
          this.filtroSel = null;
          this.filtro_guardado = datosResp.DATA;
          this.SELECT_FILTRO();
          Swal.fire({
            position: 'top-end',
            toast: true,
            icon: 'success',
            text: 'Dato Eliminado exitosamente',
            showConfirmButton: false,
            timer: 5000
          });
        },
        error => {
          Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
          });
        }
      );
    }
  }

  onFilter(event) {
    if (event != null) {
     this.formFiltros = event.SYS20FIL;
     this.filtroGuardado = true;
     //this.activeOffcanvas.close(this.formFiltros);
    } else {
      this.formFiltros = null;
    }
  }

  getObtenerCodigoCampo(label) {
    for (const i in this.estructura) {
      if (this.estructura[i].A03COD == label) {
        return this.estructura[i];
      }
    }
    return null;
  }
}
